/**
 * Az aktuális árfolyamokat táblázatban megjelenítő komponens
 * @author Koppany Kiss 2017.05.17.
 */
import vallalatiKapcsolatFormTemplate from './vallalati-kapcsolat-form.pug';
import 'angular-messages';
import RefreshSelects from './../../../common/utils/refresh-selects';
import vcRecaptcha from 'angular-recaptcha';
import {EMAIL_PATTERN, PHONE_PATTERN, SIMPLE_TEXT_PATTERN, NUMBER_PATTERN} from '../../../common/constants/consts';

const MODULE_NAME = 'vallalatiKapcsolatForm';
class VallalatiKapcsolatFormController extends RefreshSelects {
	constructor($http, $rootScope, vcRecaptchaService, $element) {
		'ngInject';
		super($element);
		this.$http = $http;
		this.rootScope = $rootScope;
		this.vcRecaptchaService = vcRecaptchaService;
	
	}

	$onInit() {
		this.model = {};
		this.patterns = {
			email: EMAIL_PATTERN,
			phone: PHONE_PATTERN,
			simpleText: SIMPLE_TEXT_PATTERN,
			number: NUMBER_PATTERN
		};
	}

	$onChanges(changeObject) {
		if (changeObject.initData && !changeObject.initData.isFirstChange()) {
			this.restMegye = angular.copy(this.initData.megyek);
			this.restTema = angular.copy(this.initData.targyak);
			this.captchaUrl = angular.copy(this.initData.captchaUrl);
			this.model.captchaId = angular.copy(this.initData.captchaId);
			this.minEmployees = angular.copy(this.initData.minAlkalmazottak);
			this.rerenderNativeSelects();
		}
		if (changeObject.errors && !changeObject.errors.isFirstChange()) {
			this.resetCaptcha();
			this.serverError = angular.copy(this.errors.data.errors);
			this.serverError.forEach((item) => {
				if (item.field == 'captcha' && item.message == 'invalid') {
					this.model.captchaValue = '';
					this.kapcsolattartoForm.captcha.$error.serverError = true;
				} else {
					this.rootScope.$broadcast('serverError');
				}
			});
		}
	}

	postContactForm() {
		if (this.kapcsolattartoForm.$valid) {
			this.postForm({
				emailObject: this.model
			});
		}
	}

	getCaptcha() {
		let now = new Date().getTime();
		this.captchaImage = this.captchaUrl.replace('{id}', `${this.model.captchaId}?${now}`);
	}

	resetCaptcha() {
		this.vcRecaptchaService.reload();
	}
}

export default angular.module(MODULE_NAME, ['ngMessages', vcRecaptcha])
	.component('vallalatiKapcsolatForm', {
		controller: VallalatiKapcsolatFormController,
		template: vallalatiKapcsolatFormTemplate(),
		bindings: {
			initData: '<',
			errors: '<',
			postForm: '&'
		}
	}).name;



// WEBPACK FOOTER //
// ../source/application/vallalati-kapcsolat/vallalati-kapcsolat-form/vallalati-kapcsolat-form.js